import { imagePrefix } from '@/constants';
import { getMiceDetail } from '@/services/api';
import React, { useEffect, useRef, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons'
import waitingIcon from '@/assets/image/waiting.png';
import videojs, { VideoJsPlayer } from 'video.js';
import 'video.js/dist/video-js.css';
import styles from './mice.less';

interface IPlayerProps {
  url?: string;
  jobId?: string;
  poster?: string;
  getVideo?: (val: any) => void

}

const MicePlayer: React.FC<IPlayerProps> = ({ jobId, poster, getVideo }) => {
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState<number>()
  const [player, setPlayer] = useState<VideoJsPlayer>()
  const [showPoster, setShowPoster] = useState(true)
  const videoRef = useRef<any>()

  useEffect(() => {
    initJobId()
  }, [jobId])

  const initJobId = async () => {
    setLoading(true)
    const result = await getMiceDetail(jobId!)
    if (result.success) {
      const { urls, meetingStatus } = result.data
      const videoNode = videoRef.current

      // 直播未开始
      if (!urls?.length || meetingStatus === 20 || meetingStatus === 30) {
        setStatus(20)
        setLoading(false)
        return
      }else{
        let hd: string = '', od: string = '', sd: string = '', ld: string = ''

        urls.forEach((item: any) => {
          if (item.bitrateType === 'HD') {
            hd = item.url
          }
          if (item.bitrateType === 'OD') {
            od = item.url
          }
          if (item.bitrateType === 'SD') {
            sd = item.url
          }
          if (item.bitrateType === 'LD') {
            ld = item.url
          }
        })
        //  HD OD SD LD 【0】
        let url: string = hd || od || sd || ld || urls[0].url
        const player = videojs(videoNode, {
          language: 'zh-CN',
          controls: true,
          preload: 'auto',
          width: videoNode?.offsetWidth,
          height: videoNode?.offsetHeight,
          sources: [
            {
              src:  `https://${url.split('://')[1]}` ,
            },
          ],
        }, function onPlayerReady() {
          getVideo && getVideo((player.el() as any).children[0])
          setPlayer(player)
          // setTimeout(() => {
          //   player.play()
          // })
        });
        player.on('play', () => {
          if (showPoster) {
            setShowPoster(false)
          }
        })
      }
    }
    // else{
    //   const videoNode = videoRef.current
    //   const player = videojs(videoNode, {
    //     language: 'zh-CN',
    //     controls: true,
    //     preload: 'auto',
    //     width: videoNode?.offsetWidth,
    //     height: videoNode?.offsetHeight,
    //     sources: [
    //       {
    //         src:  jobId == '100366912' ? 'https://mgc-video-store.oss-cn-hangzhou.aliyuncs.com/hls/198491740476284930/2022-09-08/mgc_product_manage_ea427896-a1f6-415f-9fbf-7534448aacb2/V_COPY/video.m3u8' : ( jobId == '100366913' ? 'https://mgc-video-store.newscdn.cn/hls/198491740476284930/2022-09-08/mgc_product_manage_ba2f2622-a367-4c35-9118-2cf086a3ad2a/V_COPY/video.m3u8' : '') ,
    //       },
    //     ],
    //   }, function onPlayerReady() {
    //     getVideo && getVideo((player.el() as any).children[0])
    //     setPlayer(player)
    //     // setTimeout(() => {
    //     //   player.play()
    //     // })
    //   });
    //   player.on('play', () => {
    //     if (showPoster) {
    //       setShowPoster(false)
    //     }
    //   })
    // }
    setLoading(false)
  }

  const renderMask = () => {
    let content = null
    // 直播
    if (loading) {
      // 加载中
      content = (
        <div
          className={`${styles.loading} ${styles.mask}`}
          style={{ backgroundImage: `url(${poster || imagePrefix('default-cover.png')})` }}
        >
          <LoadingOutlined style={{ fontSize: '60px', color: '#fff' }} />
        </div>
      )
    } else if (status === 20) {
      // 未开始
      content = <div
        className={`${styles.notStart} ${styles.mask}`}
        style={{ backgroundImage: `url(${poster || imagePrefix('default-cover.png')})` }}
      >
        <div className={styles.text}>
          {/* <img src={waitingIcon} alt="" />
          直播未开始，敬请期待！ */}
        </div>
      </div>
    }
    return content
  }
  // 直播开始
  return (
    <div className={styles.index}>
      {renderMask()}
      <video
        x5-video-player-type="h5"
        className="video-js"
        ref={videoRef}
      />
      {showPoster && <div
        className={styles.poster}
        style={{
          backgroundImage: `url(${poster || imagePrefix('default-cover.png')})`
        }}
        onClick={() => {
          if (player) {
            player.play()
            setShowPoster(false)
          }
        }}
      >
        <div className={styles.btn} />
      </div>}
    </div>
  );
};



export default MicePlayer;